<template>
  <!-- <h3 class="font-semibold text-gray-700 text-xl">Cajas por calibre</h3> -->
  <div id="chart5">
    <apexchart
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessGraphicsCropSizePackagesByWeeks",
  components: {
    apexchart: VueApexCharts
  },
  props: { data: { required: true } },
  data() {
    return {
    };
  },
  computed: {
    options: function () {
      return {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: { show: true },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            dataLabels: {
            }
          }
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: val => this.numberWithPrecision(val)
          },
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
        },
        title: {
          text: "Calibres (cajas)",
          offsetX: 15,
          style: { fontSize: "20px" }
        },
        legend: {
          position: "bottom",
        },
        yaxis: {
          labels: {
            show: true,
            formatter: val => this.numberWithPrecision(val)
          }
        },
        xaxis: {
          tickPlacement: "between",
          group: {
            style: {
              fontSize: "14px",
              fontWeight: 500
            },
            groups: this.groups
          },
        },
        fill: {
          opacity: 1
        },
        colors: [
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#3b82f6",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      }
    },
    groups: function () {
      return Object.keys(this.data.months).map(month => {
        return {
          title: month,
          cols: this.data.months[month].length
        }
      })
    },
    series() {
      let series = [];
      this.data.crop_sizes.forEach(crop_size => {
        series.push({
          name: crop_size.name,
          data: this.cropSizeData(crop_size),
        });
      })
      return series;
    },
  },
  methods: {
    barWidth() {
      if (Object.keys(this.data.months.length) < 3) return "20%";
      if (Object.keys(this.data.months.length) < 6) return "50%";
      return "70%";
    },
    cropSizeData: function (crop_size) {
      let data = [];
      Object.keys(this.data.months).forEach(month => {
        this.data.months[month].forEach(week => {
          let pk = this.data.packages.find(pkg => pkg.month == month && pkg.week == week && pkg.exporter_process_crop_size_id == crop_size.id);
          let quantity = pk?.quantity || 0;
          data.push({ x: week, y: quantity });
        })
      })
      return data;
    }
  }
};
</script>
